export const service_url = "https://aensaecuador.org:8543/aensaServices";
//export const service_url = "http://localhost:8081/aensaServices";
export const cookieValue = "JSESSIONID=XnDyLdfeNgbI0iK4KxHyvPx2u-1vhb3UOqqzA3po.serverone";

export function URLJoin(base, route) {
  let route_list = route.split("/");
  var result = [base];
  route_list.forEach((elem) => {
    if (elem) {
      result.push(elem);
    }
  });
  return result.join("/");
}
